import {connect} from 'react-redux';
import RenameDialog from './RenameDialog';

export default connect(
    state => {
        return {
            folders: state.menu.roots
        }
    }
)(RenameDialog);